// import {
//     DeleteOutlined,
//     EditFilled
// } from "@ant-design/icons";
// import {
//     Button, Col, Image
// } from "antd";
// import { useEffect, useState } from "react";
// import { authApis } from "../../../services/authApi";
// import Paginate from "../../../commons/Paginate";
// import MainLayout from "../../../components/mainLayout";
// import "./index.scss";
// import { ROOT_URL } from "../../../constants/api";
// import { Link } from 'react-router-dom';

// const Register = () => {
//     const [data, setData] = useState([]);
//     const [searchValue, setSearchValue] = useState("");
//     useEffect(() => {
//         authApis.getUserList()
//             .then((data) => {
//                 setData(data.users ?? [])
//             })
//             .catch((errors) => {
//                 nofication('error', 'Thất bại', 'Lấy dữ liệu thất bại');
//             });
//     }, [])

//     return (
//         <MainLayout
//             isShowActionHeader={true}
//             title="User"
//             link="/user/"
//             setSearchValue={setSearchValue}
//         >
//             <Col span={24} className='main-min-height'>
//                 <div
//                     style={{
//                         width: "100%",
//                         margin: "20px 10px 0px 0px",
//                         padding: "20px",
//                         borderRadius: "10px",
//                         background: "white",
//                     }}
//                 >
//                     <table className="table table-bordered">
//                         <thead>
//                             <tr>
//                                 <th scope="col">Select</th>
//                                 <th scope="col">id</th>
//                                 <th scope="col">Name</th>
//                                 <th scope="col">Email</th>
//                                 <th scope="col">Action</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {data.map((item, index) => {
//                                 return (
//                                     <tr key={index}>
//                                         <th scope="row">
//                                             <input type="checkbox" />
//                                         </th>
//                                         <th scope="row">{item.id}</th>
//                                         <th scope="row">
//                                             {item.name}
//                                         </th>
//                                         <td>
//                                             {item.email}
//                                         </td>
//                                         <td>
//                                             <Link to={`/user/edit/${item.id}`}>
//                                                 <Button
//                                                     icon={<EditFilled />}
//                                                     style={{
//                                                         color: "white",
//                                                         background: "black",
//                                                         border: "black",
//                                                     }}
//                                                 ></Button>
//                                             </Link>
//                                             <Button
//                                                 icon={<DeleteOutlined />}
//                                                 style={{
//                                                     color: "white",
//                                                     background: "#ab1a1a",
//                                                     border: "#ab1a1a",
//                                                     marginLeft: 10,
//                                                 }}
//                                             ></Button>
//                                         </td>
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                     <Paginate />
//                 </div>
//             </Col>
//         </MainLayout>
//     );
// };

// export default Register;


import {
    DeleteOutlined,
    EditFilled,
    ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Button, Col, Image, Modal, Tag, Spin } from "antd";
import { useEffect, useState } from "react";
import { authApis } from "../../../services/authApi";
import Paginate from "./../../../commons/Paginate";
import MainLayout from "./../../../components/mainLayout";
import "./index.scss";
import { ROOT_URL } from "../../../constants/api";
import { Link } from "react-router-dom";
import { nofication } from "./../../../commons/Nofication";
import moment from "moment";

const Register = () => {
    const [userList, setUserList] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [paginateCurrent, setPaginateCurrent] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, [paginateCurrent, perPage, searchValue]);

    const fetchData = () => {
        const urlParams = `page=${paginateCurrent}&perPage=${perPage}&search=${searchValue}`;
        authApis
            .getUserList(urlParams)
            .then((data) => {
                setUserList(data.users.data ?? []);
                setTotalItem(data.users.total ?? 0);
                setIsLoading(false);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };

    const onDelete = (id) => {
        authApis
            .deleteNews(id)
            .then((data) => {
                nofication("success", "Thành công!", "Xóa dữ liệu thành công!");
                fetchData();
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };
    const onConfirmDelete = (id) => {
        Modal.confirm({
            title: "Confirm",
            icon: <ExclamationCircleOutlined />,
            content: "Bạn có muốn xóa?",
            okText: "Ok",
            cancelText: "Cancel",
            onOk: () => {
                onDelete(id);
            },
            onCancel() {
                return;
            },
        });
    };

    return (
        <MainLayout
            isShowActionHeader={true}
            title="User"
            link="/user/list"
            titleNew="User / List"
            setSearchValue={setSearchValue}
            isHiddenAction={true}
        >
            <Spin spinning={isLoading}>
                <Col span={24} className='content-main'>
                    <div
                        style={{
                            width: "100%",
                            margin: "20px 10px 0px 0px",
                            padding: "20px",
                            borderTopRightRadius: "10px",
                            borderTopLeftRadius: "10px",
                            background: "white",
                        }}
                        className='table'
                    >
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Select</th>
                                    <th scope="col">id</th>
                                    <th scope="col">First Name</th>
                                    <th scope="col">Last Name</th>
                                    <th scope="col">Email</th>
                                    {/* <th scope="col">Action</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {userList.length ? (
                                    userList.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">
                                                    <input type="checkbox" />
                                                </th>
                                                <th scope="row">{item.id}</th>
                                                <th scope="row">
                                                    {item.first_name}
                                                </th>
                                                <th scope="row">
                                                    {item.last_name}
                                                </th>
                                                <td>
                                                    {item.email}
                                                </td>
                                                {/* <td>
                                                    <Link to={`/user/edit/${item.id}`}>
                                                        <Button
                                                            icon={<EditFilled />}
                                                            style={{
                                                                color: "white",
                                                                background: "black",
                                                                border: "black",
                                                            }}
                                                        ></Button>
                                                    </Link>
                                                    <Button
                                                        icon={<DeleteOutlined />}
                                                        style={{
                                                            color: "white",
                                                            background: "#ab1a1a",
                                                            border: "#ab1a1a",
                                                            marginLeft: 10,
                                                        }}
                                                    ></Button>
                                                </td> */}
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        {isLoading === false ? (
                                            <td colspan="9">
                                                <h4
                                                    style={{
                                                        textAlign: "center",
                                                        margin: "20px 0px",
                                                    }}
                                                >
                                                    (No data)
                                                </h4>
                                            </td>
                                        ) : (
                                            <></>
                                        )}
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>
                    <div style={{
                        width: "100%",
                        padding: "20px",
                        background: "white",
                        borderBottomRightRadius: "10px",
                        borderBottomLeftRadius: "10px",
                    }}>
                        <Paginate
                            setPaginateCurrent={setPaginateCurrent}
                            setPerPage={setPerPage}
                            totalItem={totalItem}
                            currentPage={paginateCurrent}
                        />
                    </div>
                </Col>
            </Spin>
        </MainLayout>
    );
};

export default Register;
